import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const projects = [
  {
    id: 1,
    title: 'Modern Villa — Full Interior',
    type: 'Interior',
    location: 'Thorndon, Wellington',
    desc: 'Complete interior repaint of a 4-bedroom villa. Walls, ceilings, trims, and doors.',
    before: 'https://static.readdy.ai/image/38235d25ca124ed59b2cbc0dcd639844/a0d4dc703ffedddffa3845e7169894f2.jpeg',
    after: 'https://static.readdy.ai/image/38235d25ca124ed59b2cbc0dcd639844/57cb1e43a1d5e20092c0ae63f048aa1e.jpeg',
  },
  {
    id: 2,
    title: 'Heritage Home — Exterior Repaint',
    type: 'Exterior',
    location: 'Newtown, Wellington',
    desc: 'Full exterior repaint&nbsp; including weatherboards, trims, and fascias.',
    before: 'https://static.readdy.ai/image/38235d25ca124ed59b2cbc0dcd639844/d91d0f0dbb4816a038d2877c9d9cea12.jpeg',
    after: 'https://static.readdy.ai/image/38235d25ca124ed59b2cbc0dcd639844/9b3a156f3670ea41374979fe125232e9.jpeg',
  },
  {
    id: 3,
    title: 'Kitchen Cabinet Spray Finish',
    type: 'Before & After',
    location: 'Lower Hutt',
    desc: 'Fine finish spraying on kitchen cabinets. Transformed from dated wood to sleek white.',
    before: 'https://readdy.ai/api/search-image?query=old%20dated%20kitchen%20cabinets%20before%20painting%20worn%20wood%20finish%20tired%20looking%20kitchen%20before%20renovation%20Lower%20Hutt%20New%20Zealand%20dated&width=700&height=500&seq=prj2003b&orientation=landscape',
    after: 'https://readdy.ai/api/search-image?query=stunning%20freshly%20spray%20painted%20kitchen%20cabinets%20white%20smooth%20flawless%20finish%20modern%20kitchen%20transformation%20after%20renovation%20beautiful%20result&width=700&height=500&seq=prj2003a&orientation=landscape',
  },
  {
    id: 4,
    title: 'Exterior Painting',
    type: 'Exterior',
    location: 'Miramar, Wellington',
    desc: 'Large-scale exterior repaint complex.',
    before: 'https://static.readdy.ai/image/38235d25ca124ed59b2cbc0dcd639844/6bd73b050b22fc60d3e310b50430265c.jpeg',
    after: 'https://static.readdy.ai/image/38235d25ca124ed59b2cbc0dcd639844/95e2dafeee1784bf2e0117b88ab067ea.jpeg',
  },
  {
    id: 5,
    title: 'exterior painting',
    type: 'Interior',
    location: 'Karori, Wellington',
    desc: 'exterior repaint.',
    before: 'https://static.readdy.ai/image/38235d25ca124ed59b2cbc0dcd639844/805520c056ab429a5420a42ef20d4a5a.jpeg',
    after: 'https://static.readdy.ai/image/38235d25ca124ed59b2cbc0dcd639844/22849a6ff8a7beb66d146c34e309a833.jpeg',
  },
  {
    id: 6,
    title: 'Roof Coating — Residential',
    type: 'Before & After',
    location: 'Upper Hutt',
    desc: 'Full roof clean, moss treatment, and professional coating application.',
    before: 'https://static.readdy.ai/image/38235d25ca124ed59b2cbc0dcd639844/4167014f04c3400192e2d234467d179b.jpeg',
    after: 'https://static.readdy.ai/image/38235d25ca124ed59b2cbc0dcd639844/1f115c0a290e71baeb77a93eb96a13ee.jpeg',
  },
];

const filters = ['All', 'Interior', 'Exterior', 'Before & After'];

export default function ProjectsPage() {
  const [active, setActive] = useState('All');
  const [selected, setSelected] = useState<typeof projects[0] | null>(null);
  const navigate = useNavigate();

  const filtered = active === 'All' ? projects : projects.filter((p) => p.type === active);

  return (
    <div className="min-h-screen">
      <Navbar />

      {/* Hero */}
      <section
        className="relative pt-32 pb-20"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=stunning%20before%20and%20after%20house%20painting%20transformation%20Wellington%20New%20Zealand%20professional%20painting%20results%20beautiful%20home%20exterior%20curb%20appeal%20premium%20quality&width=1440&height=500&seq=prjhero001&orientation=landscape')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="absolute inset-0 bg-[#1C1C1C]/80" />
        <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10 text-center">
          <span className="inline-block text-gray-400 text-sm font-semibold tracking-widest uppercase mb-4">Portfolio</span>
          <h1 className="text-5xl md:text-6xl font-black text-white mb-5 tracking-tight">Our Work</h1>
          <p className="text-white/70 text-lg max-w-2xl mx-auto">
            Real results from real projects across Wellington & Hutt Valley. See the transformation we deliver.
          </p>
        </div>
      </section>

      <main className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          {/* Filters */}
          <div className="flex flex-wrap gap-3 mb-12 justify-center">
            {filters.map((f) => (
              <button
                key={f}
                onClick={() => setActive(f)}
                className={`px-5 py-2.5 rounded-full text-sm font-semibold whitespace-nowrap transition-all cursor-pointer ${
                  active === f ? 'bg-[#2D2D2D] text-white' : 'bg-[#F5F5F5] text-gray-600 hover:bg-[#F0F0F0] hover:text-[#2D2D2D]'
                }`}
              >
                {f}
              </button>
            ))}
          </div>

          {/* Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {filtered.map((project) => (
              <div
                key={project.id}
                className="rounded-2xl overflow-hidden bg-[#F5F5F5] group cursor-pointer hover:-translate-y-1 transition-all duration-300"
                onClick={() => setSelected(project)}
              >
                <div className="relative h-56 overflow-hidden">
                  <img
                    src={project.after}
                    alt={`${project.title} - After`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
                  <div className="absolute top-3 left-3 flex gap-2">
                    <span className="bg-[#2D2D2D] text-white text-xs font-bold px-2.5 py-1 rounded-full">{project.type}</span>
                    <span className="bg-green-500 text-white text-xs font-bold px-2.5 py-1 rounded-full">After</span>
                  </div>
                  <div className="absolute bottom-3 right-3 bg-white/90 text-gray-700 text-xs font-bold px-3 py-1 rounded-full opacity-0 group-hover:opacity-100 transition-opacity">
                    View Before &amp; After
                  </div>
                </div>
                <div className="relative h-24 overflow-hidden border-t-2 border-dashed border-gray-200">
                  <img
                    src={project.before}
                    alt={`${project.title} - Before`}
                    className="w-full h-full object-cover object-top opacity-75"
                  />
                  <div className="absolute inset-0 bg-black/30 flex items-center justify-center">
                    <span className="bg-white/90 text-gray-700 text-xs font-bold px-3 py-1 rounded-full">Before</span>
                  </div>
                </div>
                <div className="p-5">
                  <h3 className="font-bold text-gray-900 text-base mb-1">{project.title}</h3>
                  <p className="text-gray-500 text-xs mb-2 leading-relaxed">{project.desc}</p>
                  <div className="flex items-center gap-1 text-gray-400 text-xs">
                    <i className="ri-map-pin-line text-[#2D2D2D]" />
                    {project.location}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </main>

      {/* Lightbox */}
      {selected && (
        <div
          className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4"
          onClick={() => setSelected(null)}
        >
          <div
            className="bg-white rounded-2xl overflow-hidden max-w-4xl w-full"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex flex-col md:flex-row">
              <div className="w-full md:w-1/2">
                <div className="relative">
                  <img src={selected.before} alt="Before" className="w-full h-64 md:h-80 object-cover object-top" />
                  <div className="absolute top-3 left-3 bg-gray-800 text-white text-xs font-bold px-3 py-1 rounded-full">Before</div>
                </div>
              </div>
              <div className="w-full md:w-1/2">
                <div className="relative">
                  <img src={selected.after} alt="After" className="w-full h-64 md:h-80 object-cover object-top" />
                  <div className="absolute top-3 left-3 bg-green-500 text-white text-xs font-bold px-3 py-1 rounded-full">After</div>
                </div>
              </div>
            </div>
            <div className="p-6 flex items-start justify-between">
              <div>
                <h3 className="font-black text-gray-900 text-xl mb-1">{selected.title}</h3>
                <p className="text-gray-500 text-sm mb-2">{selected.desc}</p>
                <div className="flex items-center gap-1 text-gray-400 text-xs">
                  <i className="ri-map-pin-line text-[#2D2D2D]" />
                  {selected.location}
                </div>
              </div>
              <div className="flex items-center gap-3 flex-shrink-0 ml-4">
                <a
                  href="/contact"
                  onClick={(e) => { e.preventDefault(); navigate('/contact'); setSelected(null); }}
                  className="px-5 py-2.5 bg-[#2D2D2D] text-white text-sm font-bold rounded-full whitespace-nowrap hover:bg-[#1a1a1a] transition-colors cursor-pointer"
                >
                  Get a Quote
                </a>
                <button
                  onClick={() => setSelected(null)}
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-gray-100 text-gray-500 hover:bg-gray-200 transition-colors cursor-pointer"
                >
                  <i className="ri-close-line" />
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* CTA */}
      <section className="py-16 bg-[#F5F5F5] text-center">
        <div className="max-w-2xl mx-auto px-6 md:px-10">
          <h2 className="text-3xl font-black text-gray-900 mb-4 tracking-tight">Want results like these?</h2>
          <p className="text-gray-500 mb-8">Get a free quote from Wellington's trusted painting experts.</p>
          <a
            href="/contact"
            onClick={(e) => { e.preventDefault(); navigate('/contact'); }}
            className="inline-flex items-center gap-2 px-8 py-4 bg-[#2D2D2D] text-white font-bold rounded-full whitespace-nowrap hover:bg-[#1a1a1a] transition-colors cursor-pointer"
          >
            Get a Free Quote <i className="ri-arrow-right-line" />
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}
